/**
 * Shared field chrome for the editor: the label idiom (icon + caps micro
 * label) and the input box — NumberField ships unstyled, so every numeric
 * input must wear this to look like an input at all.
 * For Media Devoted | Created By Ciro Autiero
 */
export const FIELD_LABEL =
  'flex items-center gap-1.5 text-[10.5px] font-semibold uppercase tracking-wider text-muted-foreground';

export const FIELD_ICON = 'h-3 w-3';

export const INPUT_CLASS =
  'h-10 rounded-md border border-input bg-transparent px-3 font-mono text-sm tabular-nums outline-none transition-colors focus:border-primary/60';
